import { ComponentProps, FC, ReactNode } from 'react'
import { CSS } from '@stitches/react'

import { Flex } from 'components/primitives'

interface Props {
  badgeCss?: CSS
  badgeChildren?: ReactNode
  badgeProps?: ComponentProps<typeof Badge>
}

const Badge: FC<Props> = ({ badgeCss, badgeChildren }) => {
  return (
    <Flex
      align="center"
      justify="center"
      css={{
        p: 16,
        h: 32,
        gap: 8,
        borderRadius: 8,
        ...badgeCss,
      }}
    >
      {badgeChildren}
    </Flex>
  )
}

export default Badge